import React from "react";
import { makeStyles } from "tss-react/mui";
import { FormTextInputDefault } from "./FormInput.js";
import { withStyledInputLabel } from "./StyledFormInputHoc.js";
const useClasses = makeStyles()((theme) => ({
  input: {
    "& .MuiInputAdornment-root": {
      color: theme.custom.palette.content.bodyText
    }
  }
}));
const StyledInputComponent = ({ className, ...props }) => {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(FormTextInputDefault, { className: `${className ?? ""} ${classes.input}`, hideLabel: true, variant: "outlined", ...props });
};
const StyledInput = withStyledInputLabel(StyledInputComponent);
export {
  StyledInput,
  StyledInputComponent
};
//# sourceMappingURL=StyledInput.js.map
